import React, { ReactElement } from 'react';

import useEditNameModalContainer from 'adapter/in/dashboards/containers/EditDashboard/EditNameModal/useEditNameModalContainer';
import { useForm } from 'react-hook-form';
import DashboardNameModal, { DashboardNameFormData } from 'adapter/in/dashboards/pages/Modals/DashboardNameModal';
import i18n from 'asset/translation';

const EditDashboardNameModalContainer = (): ReactElement => {
    const { dashboardOriginalName, onSubmit, showModal, onModalCancel, isLoading, error, success } = useEditNameModalContainer();
    const { handleSubmit: reactFormSubmit, control, setValue } = useForm<DashboardNameFormData>();

    const handleFormSubmit = () => {
        reactFormSubmit((data: DashboardNameFormData) => {
            onSubmit(data.name);
        })();
    };

    const closeAndResetForm = () => {
        onModalCancel();
        setValue('name', dashboardOriginalName);
    };

    return (
        <DashboardNameModal
            title={i18n.t('dashboards.edit.renameModalTitle')}
            defaultValue={dashboardOriginalName}
            success={success}
            handleOnSubmit={handleFormSubmit}
            showModal={showModal}
            handleCloseModal={closeAndResetForm}
            isLoading={isLoading}
            error={error}
            control={control}
        />
    );
};

export default EditDashboardNameModalContainer;
